export const transactionMethods = [
  'card',
  'cheque',
  'directDebit',
  'iban',
  'ideal',
  'internal',
  'mbWay',
  'multibanco',
  'pagare',
  'rib',
  'soFort',
  'bnpl',
  'paypal'
];

export const paymentMethods = [
  { value: 0, text: 'card' },
  { value: 1, text: 'rib' },
  { value: 3, text: 'iban' },
  { value: 4, text: 'internal' },
  { value: 14, text: 'directDebit' },
  { value: 15, text: 'cheque' },
  { value: 17, text: 'soFort' },
  { value: 19, text: 'multibanco' },
  { value: 21, text: 'mbWay' },
  { value: 23, text: 'pagare' },
  { value: 30, text: 'bnpl' },
  { value: 35, text: 'paypal' },
  { value: 6, text: 'vcc' },
  { value: 11, text: 'agc' },
  { value: 12, text: 'cbv' },
  { value: 16, text: 'neosurf' },
  { value: 18, text: 'pfsPhysicalCard' },
  { value: 20, text: 'payshop' },
  { value: 22, text: 'polishInstantTransfer' },
  { value: 24, text: 'mobilePay' },
  { value: 25, text: 'payTrail' },
  { value: 26, text: 'weChat' },
  { value: 27, text: 'p24' },
  { value: 28, text: 'moneyInByTpe' },
  { value: 29, text: 'trustly' },
  { value: 38, text: 'ideal' },
  { value: 39, text: 'banContact' },
  { value: 100, text: 'cancel' }
];

export const paymentMeanDataProviders = {
  APPLEPAY: 'Apple Pay',
  ALMA3X: 'ALMA3X',
  ALMA4X: 'ALMA4X'
};

export const bankTransferTypes = [
  { value: 'standard', text: 'standard' },
  { value: 'Pay By Bank', text: 'payByBank' },
  { value: 'Pay By Bank Instant', text: 'payByBankInstant' }
];
